export function isEdge(id?: string) {
  return id?.startsWith('edge')
}
